<template>
  <div>
    <div class="w-full h-full flex flex-col md:flex-row gap-4 py-5">
      <button
        :class="[selectedAnswer === true ? 'border-primary bg-primary' : 'border-brand-gray-600']"
        class="flex-1 rounded-md border hover:text-primary hover:border-primary py-12 bg-brand-gray-150"
        @click="$emit('onStep1Answer', true)"
      >
        <span :class="{ 'text-white': selectedAnswer === true }">
          {{ $t('NewRegisterVisaHolder') }}
        </span>
      </button>
      <button
        :class="[selectedAnswer === false ? 'border-primary bg-primary' : 'border-brand-gray-600']"
        class="flex-1 rounded-md border hover:text-primary hover:border-primary py-12 bg-brand-gray-150"
        @click="$emit('onStep1Answer', false)"
      >
        <span :class="{ 'text-white': selectedAnswer === false }">
          {{ $t('NewRegisterGCC') }}
        </span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import router from '@/router'

const modal = ref(null)
const selectedAnswer = ref(null)

watch(modal, (newValue) => {
  if (newValue === false) {
    document.body.style.overflow = 'inherit'
    router.replace('/')
  }
})
</script>

<style lang="scss" scoped></style>
